
import { useState } from "react";
import { useSelector } from "react-redux";

import Box from "@mui/material/Box";
import { Paper, Stack } from "@mui/material";

export default function HourlyDeskUpsertDataMonitoring() {

  const [show, setShow] = useState(false)
  const hourly_desk_upserts  = useSelector( store => store.hourly_desk_upsert.hourly_desk_upserts) //fetchHourlyDeskUpsert

  function handleClick(){
    setShow(!show)
  }

  return (
    <Paper
      sx={{
        padding: 2,
        mt: 1
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>

        <Stack>
        <div>
          <button onClick={handleClick}>
            Show/Hide HourlyDeskUpsert Fetch Status
          </button>
        </div>

        { show == true &&
          <div>
            <h1>
              HourlyDeskUpsert Data Monitoring
            </h1>
            { hourly_desk_upserts?.length >0  ? <p> fetchHourlyDeskUpsert  ✅</p> : <p>  fetchHourlyDeskUpsert ❌</p> }

          </div>
        }
        </Stack>

      </Box>
    </Paper>
  );
}
